import * as React from "react";
import { useAccount, State } from "@grandvisionhq/auth";
import { Button } from "@grandvisionhq/common";
import { Heading, Divider } from "@grandvisionhq/elements";
import { useLink } from "@grandvisionhq/frk-routing";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { DownloadInvoiceForm } from "../../components/components/DownloadInvoiceForm.js";
import useDownloadInvoice from "../../hooks/hooks/use-download-invoice.js";
import { DownloadInvoiceError } from "../../types.js";
/* empty css                              */
const DownloadInvoiceContainer = () => {
  const { downloadInProgress, handleDownloadInvoice, downloadError } = useDownloadInvoice();
  const authState = useAccount();
  const isAuthLoading = authState === "UNKNOWN";
  const isUserLoggedIn = authState === State.AuthState.LoggedIn;
  const ordersRouteLink = useLink({ route: "me.orders" });
  const loginRouteLink = useLink(
    isUserLoggedIn ? { route: "me.orders" } : { route: "auth.login", params: { returnPath: ordersRouteLink?.href } }
  );
  const [downloadFailed, setDownloadFailed] = React.useState(false);
  const { getLabel, getFormattedLabel } = useIntl();
  const downloadInvoice = (formData) => {
    downloadFailed && setDownloadFailed(false);
    if (formData.formValid) {
      handleDownloadInvoice({
        dateOfBirth: formData.formState.dateOfBirth?.value || "",
        emailId: formData.formState.email?.value || "",
        orderNumber: formData.formState.orderNumber?.value || ""
      });
    }
  };
  const buttonLabel = !isUserLoggedIn ? "checkout.download.invoice.signin.label" : "checkout.download.invoice.orders.label";
  React.useEffect(() => {
    if (downloadError) {
      setDownloadFailed(true);
    }
  }, [downloadError]);
  const getErrorMessage = (downloadErrorCode) => {
    switch (downloadErrorCode) {
      case DownloadInvoiceError.INVALID_CUSTOMER_INFO:
        return getFormattedLabel("checkout.download.invoice.invalid.input.title", {
          parseLink: true
        });
      case DownloadInvoiceError.INVALID_ORDER_STATUS:
      case DownloadInvoiceError.GENERIC_ERROR:
      default:
        return getFormattedLabel("checkout.download.invoice.not.ready.title", {
          parseLink: true
        });
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "download-invoice__container" }, /* @__PURE__ */ React.createElement(Heading, { className: "download-invoice__heading", component: "h2", variant: "small", align: "left" }, getLabel("checkout.download.invoice.title")), /* @__PURE__ */ React.createElement(
    Heading,
    {
      className: "download-invoice__subheading",
      component: "p",
      variant: "subheading2",
      align: "left"
    },
    getLabel("checkout.download.invoice.description")
  ), downloadFailed && /* @__PURE__ */ React.createElement(
    Alert,
    {
      className: "alert-m-default download-invoice__alert",
      variant: "error",
      title: getLabel("checkout.download.invoice.failed.title")
    },
    getErrorMessage(downloadError)
  ), /* @__PURE__ */ React.createElement(DownloadInvoiceForm, { onSubmit: downloadInvoice, submitInProgress: downloadInProgress }), /* @__PURE__ */ React.createElement(Divider, { caption: getLabel("checkout.download.invoice.action.separator.label") }), /* @__PURE__ */ React.createElement(
    Button,
    {
      caption: getLabel(buttonLabel),
      className: "download-invoice__button",
      "data-t": "sign-in-button",
      isLoading: isAuthLoading,
      onClick: isUserLoggedIn ? ordersRouteLink?.onClick : loginRouteLink?.onClick,
      variant: "outline"
    }
  ));
};
export {
  DownloadInvoiceContainer
};
//# sourceMappingURL=DownloadInvoiceContainer.js.map
